<template>
  <div class="mian-container" @click="onContainerClick">
    <div class="node-container">
      <AddNodeButton
        @click="showCommon = true"
        title="普通节点"
        type="primary"
      />
      <AddNodeButton
        @click="showCollect = true;"
        title="采集节点"
        type="primary"
      />
      <AddNodeButton
        @click="showJump = true;"
        title="跳转节点"
        type="warning"
      />
      <AddNodeButton
        @click="showCondition = true;"
        title="条件节点"
        type="warning"
      />
      <AddNodeButton
        @click="showLLM = true;"
        title="llm"
        type="warning"
        v-if="access.flowLlm"
      />
      <AddNodeButton
        @click="showLLMPro = true;"
        title="llm pro"
        type="warning"
        v-if="access.flowLlm"
      />
    </div>
    <div class="save-style">
      <Button 
        type="primary" 
        ghost 
        @click="openImportExport" 
        class="import-export-btn"
        style="margin-right: 12px"
        size="large"
        v-if="isOperator || access.flowImportExport"
      >
        <Icon type="md-archive" />
        导入/导出
      </Button>
      <Poptip
        class="poptip"
        confirm
        title="不合适的话术可能会产生损失，请仔细确认"
        placement="left-start"
        :disabled="state === 0"
        @on-ok="handleSave(1)">
        <Button type="warning" @click="handleSave()" size="large" :loading="submitting">保存</Button>
      </Poptip>
    </div>
    <div class="draw-con">
      <div id="Container" class="draw-wrap" ref="Container">
        <div
          v-for="(item, index) in nodes"
          :class="{ play: 'item', collect: 'item', jump: 'jump-item', condition: 'item', llm: 'llm-item', thirdllm: 'llm-item' }[item.type]"
          :style="{ top: `${item.top}px`, left: `${item.left}px` }"
          class="bgc-style"
          :id="item.id"
          :key="index"
          @dblclick="nodeDblclick(item)"
          @click="nodeClickHandler(item, $event)"
        >
          <div class="top-container">
            <span class="title-style">
              {{ item.name }}
                <span v-if="index === 0">(开始)</span>
                <Poptip v-else
                  confirm
                  title="确定要设置该节点为开始节点吗？"
                  @on-ok="setStartNode(item.id)"
                  transfer
                >
                  <a>设为开始</a>
                </Poptip>
                <Tooltip
                  v-if="nodeHitStat(curFlowId, item.id)"
                  content="到达率:到达该节点的通话数/接通数"
                  transfer
                >
                  <span class="node-hit-badge">
                    {{ nodeHitStat(curFlowId, item.id).percent }}%
                  </span>
                </Tooltip>
            </span>
            <div class="icon-style">
              <Icon
                color="#7f9fd5"
                type="ios-copy-outline"
                @click="showCopy(item)"
              />
              <Icon
                color="#7f9fd5"
                type="ios-create-outline"
                @click="showAddNode(item)"
              />
              <Icon
                color="#ed4014"
                type="ios-trash-outline"
                @click="delNode(item.id)"
              />
              <audio-play :filepath="getVoiceFile(item)" class="audioPlay"/>
              <audio class="audio" ref="audio" :src="item.voice" />
            </div>
          </div>
          <div class="text-container">
            <div v-if="item.type == 'jump'">
              <span>下一步：</span>
              <span v-if="item.action === 'jump'">
                <span v-if="item.action_data">
                  {{flowMap[item.action_data.split(',')[0]] && flowMap[item.action_data.split(',')[0]].name}}
                </span>
                <span v-if="item.action_data">
                  {{getNodeName(...item.action_data.split(','))}}
                </span>
              </span>
              <span v-else>{{ { hangup: '挂机', transfer: '转接' }[item.action] }}</span>
            </div>
            <div v-if="item.type == 'llm' || item.type == 'llmPro'">
              <p><span>模型：</span><span>{{ item.model }}</span></p>
              <p><span>提示语：</span><span>{{ item.prompt }}</span></p>
            </div>
            <Tooltip max-width="400" :content="item.voices && item.voices[0] && item.voices[0].text">
              <div class="node-voices-text">
                {{item.voices && item.voices[0] && item.voices[0].text}}
              </div>
            </Tooltip>
          </div>
          <div v-if="item.type == 'play' || item.type == 'collect'" class="btn-container">
            <template
              v-for="(op, index) in item.outs"
            >
              <branch-tip
                :key="index"
                v-if="op.intent_id !== '_knowledge'"
                :conditions="op.conditions"
                class="btn-item"
                :class="{ unconnected: !op.target_id }"
                :id="op.id"
                :data-pid="op.group"
                @mouseover.native="handleBranchHover(op)"
                @mouseleave.native="handleBranchLeave(op)"
              >
              {{op.group}}
                {{ intentsMap[op.intent_id] && intentsMap[op.intent_id].name }}
              </branch-tip>
            </template>
          </div>
          <div v-if="item.type == 'condition'" class="btn-container">
            <template
              v-for="(out, index) in item.outs"
            >
              <span
                class="btn-item"
                :class="{ unconnected: !out.target_id }"
                :key="index"
                :id="out.id"
              >
                {{ out.name }}
              </span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加普通节点 -->
    <addCommonNode
      v-model="showCommon"
      @addCommon="addNodeHandler"
      @editCommonNode="editNodeHandler"
      @cancel="nodeDetail = undefined"
      :nodeDetail="nodeDetail"
    />
    <!-- 添加采集节点 -->
    <add-collect-node
      v-model="showCollect"
      :nodeDetail="nodeDetail"
      @addNode="addNodeHandler"
      @editNode="editNodeHandler"
      @cancel="nodeDetail = undefined"
    />
    <!-- 添加跳转节点 -->
    <add-jump-node
      v-model="showJump"
      :nodeDetail="nodeDetail"
      @addNode="addNodeHandler"
      @editNode="editNodeHandler"
      @cancel="nodeDetail = undefined"
    />
    <!-- 添加条件节点 -->
    <add-condition-node
      v-model="showCondition"
      :nodeDetail="nodeDetail"
      @addNode="addNodeHandler"
      @editNode="editNodeHandler"
      @cancel="nodeDetail = undefined"
    />
    <!-- 添加llm节点 -->
    <addLLMNode
      v-model="showLLM"
      @addNode="addLLMHandler"
      @editNode="editNodeHandler"
      @cancel="llmNodeCancel"
      :nodeDetail="nodeDetail"
    />
    <!-- 添加 llm pro 节点 -->
    <addLLMProNode
      v-model="showLLMPro"
      @addNode="addLLMProHandler"
      @editNode="editNodeHandler"
      @cancel="llmProNodeCancel"
      :nodeDetail="nodeDetail"
    />
    <CopyModal v-model="copyVisible" :copyData="copyNode" @addNode="addNodeHandler"/>
    <!-- 导入/导出弹窗 -->
        <ImportExportModal v-model="importExportVisible" />
  </div>
</template>
<script>
import {
  FLOW,
  CONFIG,
} from '../../../utils/flow';
import addCommonNode from './AddCommonNode';
import AddCollectNode from './AddCollectNode.vue';
import AddJumpNode from './AddJumpNode.vue';
import AddNodeButton from './AddNodeButton';
import AddConditionNode from './AddConditionNode';
import AddLLMNode from './AddLLMNode';
import AddLLMProNode from './AddLLMProNode';
import CopyModal from './CopyModal';
import { mapState, mapActions, mapGetters } from 'vuex';
import { addNodeId } from '@/utils/nodeIdPool';
import BranchTip from '../../../components/BranchTip.vue';
import AudioPlay from '../../../components/AudioPlay.vue';
import ImportExportModal from '@/components/ImportExportModal.vue'

window.FLOW = FLOW;

export default {
  components: {
    addCommonNode,
    AddNodeButton,
    AddJumpNode,
    AddCollectNode,
    AddConditionNode,
    AddLLMNode,
    AddLLMProNode,
    CopyModal,
    BranchTip,
    AudioPlay,
    ImportExportModal,
  },
  data() {
    return {
      showCommon: false,
      showJump: false,
      showCollect: false,
      showCondition: false,
      showLLM: false,
      showLLMPro: false,
      nodeDetail: undefined,
      title: '增加节点',
      submitting: false,
      copyNode: undefined,
      copyVisible: false,
      highlightedConnections : [],//高亮连接线
      hoverTimer :null,
      importExportVisible: false,
    };
  },
  computed: {
    ...mapGetters('flow', ['nodes', 'flowMap', 'nodeHitStat']),
    ...mapState('scene', ['state']),
    ...mapState('flow', ['flows', 'curFlowId']),
    ...mapGetters('intents', ['intentsMap']),
    ...mapState('user', ['access']),
    isOperator() {
      return window.isOperator
    },
  },
  mounted() {
    jsPlumb.ready(() => {
      let _base = FLOW._base;
      let plumb = {};
      // 实例化jsplumb
      _base.plumb = jsPlumb.getInstance({
        //  设置连线
        // Bezier(贝塞尔曲线，默认)、Straight(直线)、Flowchart(流程图线)、StateMachine(状态线)
        Connector: [
          CONFIG.conn.connectionType, // 连线类型
          {
            gap: CONFIG.conn.connectionGap, // 连线到端点的距离
            cornerRadius: CONFIG.conn.connectionCornerRadius, // 连线圆角程度
            alwaysRespectStubs: CONFIG.conn.connectionAlwaysRespectStubs,
          },
        ],
        // 给连线添加箭头，写在配置中的名字为 connectorOverlays，写在连接中的名字为 overlays
        // location 0.5 表示箭头位于中间，location 1 表示箭头设置在连线末端。 一根连线是可以添加多个箭头的。
        ConnectionOverlays: [
          [
            'Arrow',
            {
              width: CONFIG.arrow.arrowWidth,
              length: CONFIG.arrow.arrowLength,
              location: CONFIG.arrow.arrowLocation,
            },
          ],
        ],
        // 设置连线样式
        PaintStyle: {
          stroke: CONFIG.conn.stroke, // 连线颜色
          strokeWidth: CONFIG.conn.strokeWidth, // 连线粗细
        },
        // 鼠标悬浮在连接线上的样式
        HoverPaintStyle: {
          stroke: CONFIG.conn.hoverConnStroke, // 悬浮颜色
        },
        // 设置端点样式
        EndpointStyle: {
          fill: CONFIG.endPonit.fill, // 填充色
          stroke: CONFIG.endPonit.stroke, // 外框色
          strokeWidth: CONFIG.endPonit.strokeWidth, // 外框厚度
          radius: CONFIG.endPonit.radius, // 半径
        },
        // 鼠标悬浮在端点上的样式
        EndpointHoverStyle: {
          fill: CONFIG.endPonit.hoverEndPointStroke, // 悬浮颜色
        },
        // 不允许拖拽取消连线
        ConnectionsDetachable: false,
      });
      // 2、建立连接前触发
      _base.plumb.bind('beforeDrop', (info) => {
        const sourceId = info.sourceId;
        const targetId = info.targetId;
        // 2.1、出现自连接直接断开
        const curOut = this.getOutInfo(sourceId)
        if (curOut?.nodeId === targetId) return false;
        if (curOut?.target_id === targetId) return false;
        if (curOut?.target_id) {
          //  移除连线
          this.deleteConnection(sourceId, curOut?.target_id);
        }
        return true;
      });
      // 3、建立连接后触发
      _base.plumb.bind('connection', ({ sourceId, targetId }) => {
        // 3.1、连线id
        const out = this.getOutInfo(sourceId)
        this.setConnection({
          nodeId: out.nodeId,
          sourceId,
          targetId,
        })
      });
      // 4、连接双击事件
      _base.plumb.bind('dblclick', (conn) => {
        this.deleteLine(conn)
      });
    });
    setTimeout(() => {
      this.loadData();
    }, 100);
  },
  methods: {
    ...mapActions('flow', ['editNode', 'setConnection', 'setNodePos', 'delFlowNode', 'submitFlow', 'switchFlow', 'setStartNode']),
    // 添加节点
    dropHandle(newNode) {
      let _base = FLOW._base;
      // 添加到节点数据中
      this.$nextTick(() => {
        this.initTarget(newNode.id);
        this.setNodeDraggable(newNode.id);
        newNode.outs?.forEach((item) => {
          if (item.intent_id !== '_knowledge') {
            this.initSource(item.id)
          }
        });
      });
    },
    // 设置节点可以被移动
    setNodeDraggable(nodeId) {
      let _base = FLOW._base;
      let that = this;
      setTimeout(() => {
        _base.plumb.draggable(nodeId, {
          filter: '.enableDraggable ',
          containment: 'parent',
          start() {},
          // 拖拽过程中实时更新节点位置
          drag(event) {},
          // 拖拽结束后更新图对象中存储的节点位置
          stop(event) {
            // 更新图对象
            let id = event.el.id;
            let x = event.pos[0];
            let y = event.pos[1];
            that.setNodePos({ id, x, y })
          },
        });
      }, 100);
    },
    // 连接两个节点
    connectNode(sourceId, targetId) {
      // 1、新增端点，一条连接线两个端点
      let _base = FLOW._base;
      try {
        this.addEndPoint(targetId, ['Top'])
        this.addEndPoint(sourceId, ['Bottom'])
        _base.plumb.connect({
          // 通过编码连接endPoint，连线不会混乱
          uuids: [sourceId, targetId],
        });
      } catch (error) {
        console.log('error :>> ', error);
      }
    },
    // 移除出口节点以及关于节点的所有连线、端点
    deleteOutEndpoint(out) {
      // 删除连线
      if (out.target_id) {
        this.deleteConnection(out.id, out.target_id)
      }
      this.deleteEndpoint(out.id);
    },
    // 移除节点端点
    deleteEndpoint(id) {
      const endPoints = FLOW._base.plumb.getEndpoints(id);
      for (let i = 0; i < endPoints.length; i++) {
        FLOW._base.plumb.deleteEndpoint(endPoints[i]);
      }
    },
    // 删除端点连线
    deleteConnection(sourceId, targetId) {
      const _base = FLOW._base;
      _base.plumb.deleteConnection(_base.plumb.getConnections({
        source: sourceId,
        target: targetId,
      })[0])
    },
    // 给节点添加端点，返回端点id
    addEndPoint(nodeId, anchors) {
      let _base = FLOW._base
      _base.plumb.addEndpoint(nodeId, {
        uuid: nodeId,
        anchors: anchors,
      })
    },
    // 设置为源节点
    initSource(id) {
      let _base = FLOW._base;
      _base.plumb.makeSource(id, {
        filter: 'a',
        filterExclude: true,
        maxConnections: -1,
        endpoint: ['Dot', { radius: 7 }],
        anchor: ['Bottom'],
      });
    },
    // 设置为目标节点
    initTarget(id) {
      let _base = FLOW._base;
      _base.plumb.makeTarget(id, {
        filter: 'a',
        filterExclude: true,
        maxConnections: -1,
        endpoint: ['Dot', { radius: 7 }],
        anchor: ['Top'],
      });
    },
    // 初始化节点数据
    loadData() {
      for (let i = 0; i < this.nodes.length; i++) {
        const node = this.nodes[i];
        this.initTarget(node.id)
        this.setNodeDraggable(node.id)
        const outs = node.outs || [];
        for (let j = 0; j < node.outs?.length; j++) {
          const out = node.outs[j];
          if (out.intent_id !== '_knowledge') {
            this.initSource(out.id)
          }
          if (!out.target_id) continue;
          this.connectNode(out.id, out.target_id);
        }
      }
    },
    // 添加节点
    handleAddCommon() {
      this.title = '增加节点';
      this.showCommon = true;
    },
    // 添加 普通节点
    addNodeHandler(data) {
      // 把数据放放库中
      this.editNode(data).then((newData) => {
        this.dropHandle(newData);
      });
    },
    // 添加 llm节点
    addLLMHandler(data) {
      // 把数据放到库中
      this.editNode(data).then((newData) => {
        this.dropHandle(newData);
      });
    },
    addLLMProHandler(data) {
      // 把数据放到库中
      this.editNode(data).then((newData) => {
        this.dropHandle(newData);
      });
    },
    llmNodeCancel() {
      this.showLLM = false;
      this.nodeDetail = undefined;
    },
    llmProNodeCancel() {
      this.showLLMPro = false;
      this.nodeDetail = undefined;
    },
    // 编辑节点
    editNodeHandler(data) {
      const curNode = this.nodes.find(node => node.id === data.id);
      if (!curNode) return;
      // 判断出口，如果是新加的则初始化，如果没有了则执行deleteOutEndpoint
      const oldOutIds = new Set();
      for (let i = 0; i < curNode.outs?.length; i++) {
        oldOutIds.add(curNode.outs[i].id);
      }
      // -> 设置source节点
      for (let i = 0; i < data.outs?.length; i++) {
        const out = data.outs[i];
        if (!out.id) {
          out.id = addNodeId('O');
          setTimeout(() => {
            if (out.intent_id !== '_knowledge') {
              this.initSource(out.id)
            }
          }, 100)
          continue;
        }
        oldOutIds.delete(out.id)
      }
      // -> 删除旧的 source节点
      for (const outId of oldOutIds) {
        const out = curNode.outs?.find(item => item.id === outId);
        this.deleteOutEndpoint(out);
      }
      // -> 保存节点信息
      this.editNode(data);
    },
    // 编辑节点
    showAddNode(item) {
      this.nodeDetail = item;
      this.title = '编辑节点';
      if (item.type == 'play') {
        this.showCommon = true;
      } else if (item.type == 'collect') {
        this.showCollect = true;
      } else if (item.type === 'jump') {
        this.showJump = true;
      } else if (item.type === 'condition') {
        this.showCondition = true;
      } else if (item.type === 'llm') {
        this.showLLM = true;
      } else if (item.type === 'thirdllm') {
        this.showLLMPro = true;
      }
    },
    // 删除节点
    delNode(id) {
      const curNode = this.nodes.find(node => node.id === id);
      if (!curNode) return;
      const outs = curNode.outs || []
      for (let i = 0; i < outs.length; i++) {
        // 删除出口 endpoint 和对应的连线
        FLOW._base.plumb.deleteConnectionsForElement(outs[i].id)
        this.deleteEndpoint(outs[i].id);
      }
      // 删除入口 endpoint 和对应的连线
      FLOW._base.plumb.deleteConnectionsForElement(id)
        this.deleteEndpoint(id);
      // 更新数据
      this.delFlowNode(id)
    },
    handleSave(type) {
      if (!type && this.state !== 0) return;
      this.submitting = true;
      // 保存前为每个 LLM Pro 节点追加一个 thirdllm 节点（仅用于底层配置）
      const llmProNodes = this.nodes.filter(node => node.type === 'llmPro');
      llmProNodes.forEach((node) => {
        this.editNode({
          type: 'thirdllm',
          name: node.name,           // 用户填写的节点名称
          agentid: node.scriptId,    // LLM Pro 中的 scriptId 作为 agentid
          tag: node.tag,
          top: node.top,
          left: node.left,
        });
      });
      this.submitFlow().then((res) => {
        this.submitting = false;
        this.$Message.success('保存成功');
      }).catch(() => {
        this.submitting = false;
      });
    },
    // 获取out节点信息
    getOutInfo(outId) {
      const nodes = this.nodes;
      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        for (let j = 0; j < node.outs?.length; j++) {
          const out = node.outs[j];
          if (out.id === outId) {
            return {
              ...out,
              nodeId: node.id,
            };
          }
        }
      }
      return -1;
    },
    // 删除连接node的所有连线
    deleteNodeConnect(nodeId) {
      const connections = FLOW._base.plumb.getConnections({ target: nodeId })
      for (let i = 0; i < connections.length; i++) {
        FLOW._base.plumb.deleteConnection(connections[i]);
      }
    },
    // 删除连线
    deleteLine(conn) {
      this.$Modal.confirm({
        title: '确定删除所点击的链接吗？',
        onOk: () => {
          const { sourceId } = conn;
          const out = this.getOutInfo(sourceId)
          this.setConnection({
            nodeId: out.nodeId,
            sourceId,
            targetId: '',
          })
          FLOW._base.plumb.deleteConnection(conn);

        }
      })
    },
    // 双击节点
    nodeDblclick(node) {
      if (node.type !== 'jump' || node.action !== 'jump' || !node.action_data) return;
      const actionData = node.action_data && node.action_data.split(',')[0]
            this.switchFlow(actionData)
    },

    showCopy(node) {
      this.copyNode = node;
      this.copyVisible = true;
    },

    getNodeName(flowId, nodeId) {
      if (!flowId || !nodeId) return ''
      for (let i = 0; i < this.flows.length; i++) {
        const flow = this.flows[i];
        if (flow.id !== flowId) continue
        for (let j = 0; j < flow.nodes.length; j++) {
          const node = flow.nodes[j];
          if (node.id === nodeId) return node.name;
        }
      }
      return ''
    },
    // 获取node节点第一个录音文件
    getVoiceFile(node) {
      const firstHasRecord = (node.voices || []).find(item => !!item.voice)
      return firstHasRecord ? firstHasRecord.voice : ''
    },

// 分支悬停处理
handleBranchHover(op) {
  this.hoverTimer = setTimeout(() => {
    const connections = FLOW._base.plumb.getConnections({ source: op.id });
    if (connections.length == 0) {
      return;
    }
    this.setConnections(this.highlightedConnections, "#999");
    this.setConnections(connections, "#ff0000");
    this.highlightedConnections = connections;
  }, 2500);
},

// 分支离开处理
handleBranchLeave(op) {
  clearTimeout(this.hoverTimer);
  if (this.highlightedConnections.length == 0) {
    return;
  }
  this.setConnections(this.highlightedConnections, "#999");
  this.highlightedConnections = [];
},

    // 新增容器点击处理
    onContainerClick(e) {
        // 判断是否点击的是节点元素
        const isNodeClick = e.target.closest('.item, .jump-item');
        if (!isNodeClick) {
            this.resetHighlightedConnections();
        }
    },

    setConnections(cs, color) {
      const validConnections = cs.filter(conn =>
        FLOW._base.plumb.getConnections().some(c => c.id === conn.id)
      );
      validConnections.forEach(conn => {
          conn.setPaintStyle({
              stroke: color,
          });
      });
    },

     // 取消上一次高亮的连线
    resetHighlightedConnections() {
        if (this.highlightedConnections.length == 0) {
          return;
        }
        this.setConnections(this.highlightedConnections, "#999");
        this.highlightedConnections = [];
    },

    highlighted(connections) {
      this.setConnections(this.highlightedConnections, "#999");
      this.setConnections(connections, "#ff0000");
      this.highlightedConnections = connections;
    },

    nodeClickHandler(node, e) {
      if (!e.target.closest('.item, .jump-item') || e.target.closest('.top-container') || e.target.closest('.icon-style, .btn-container')) {
        return;
      }
      // 获取当前节点的所有连接
      const connections = FLOW._base.plumb.getConnections({ target: node.id });
      if (connections.length == 0) {
        this.resetHighlightedConnections();
        return;
      }

      this.highlighted(connections);
    },

    openImportExport() {
            this.importExportVisible = true;
        }
  },
};
</script>
<style lang="scss" scoped>
.mian-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 3;
  user-select: none;
  position: relative;
  .node-container {
    width: 350px;
    height: 80px;
    background-color: #eee;
    border-radius: 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 999;
  }
  .draw-con {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  #Container {
    width: 3000px;
    height: 2000px;
    position: absolute;
  }
  .item {
    max-width: 400px;
    min-width: 220px;
    position: absolute;
    border: 1px solid #7f9fd5;
    border-radius: 8px;
    padding: 0 20px 15px;
  }
  .jump-item {
    max-width: 400px;
    position: absolute;
    background-color: #c9ddff;
    border-radius: 8px;
    padding: 0 20px 15px;
  }
  .llm-item {
    max-width: 400px;
    position: absolute;
    background-color: #f1e7c7;
    border-radius: 8px;
    padding: 0 20px 15px;
  }
  .icon-style {
    font-size: 20px;
    text-align: right;
    // padding-right: 20px;
    i {
      font-weight: 700;
      margin-right: 5px;
      cursor: pointer;
    }
  }
  .title-style {
    position: absolute;
    top: -10px;
    left: 20px;
    white-space: nowrap;
  }
  .node-hit-badge {
    display: inline-block;
    margin-left: 8px;
    padding: 1px 8px;
    border-radius: 10px;
    background-color: #ff9c00;
    color: #fff;
    font-size: 12px;
    line-height: 1.4;
    vertical-align: middle;
  }
  .text-container {
    text-align: left;
    padding: 0 10px;
  }
  .node-voices-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .btn-container {
    .btn-item {
      display: inline-block;
      padding: 5px 10px;
      border: 2px solid #7f9fd5;
      color: #7f9fd5;
      margin: 10px 5px 0 0;
      &:hover {
        box-shadow: 0 0 5px #7f9fd5;
      }
      &.unconnected {
        border-color: #ed4014;
        color: #d4380d;
        background-color: #fff1f0;
      }
    }
  }
}
.draw-wrap {
  flex: 1;
  overflow: auto;
}
.bgc-style {
  background-color: #fff;
}
.test {
  position: absolute;
  top: 500px;
  left: 100px;
}
.text {
  position: absolute;
  top: 700px;
  left: 100px;
  border: 1px solid #aaa;
  width: 50px;
  height: 50px;
}
.save-style {
  position: absolute;
  right: 40px;
  top: 20px;
  z-index: 1;
  button {
    cursor: pointer;
  }
}
.poptip {
  text-align: left;
}
.audioPlay {
  vertical-align: -.125em;
}
</style>
